import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";

const getCorTitleDocs = createAsyncThunk(
  "corTitleDocs/getAll",
  async ({ direction }) => {
    const { request } = useHttp();
    return await request({
      url: `/cor_management/cor_man_title_docs/?direction=${direction}`,
    });
  }
);

export { getCorTitleDocs };
